import React from "react";
import { Link } from "react-router-dom";

const CommunityGuide = () => {
  return (
    <div className="content">
      <h2>
        <Link to="/">Home</Link> / Community Guidelines
      </h2>
      <br />

      <p align="center">
        <b>ShareMy Community Guidelines</b>
      </p>

      <p>
        <b>1. Introduction</b>
      </p>
      <p>Welcome to the ShareMy community.</p>
      <p>
        These Community Guidelines establish the standards of conduct expected
        of everyone who uses the ShareMy Services. They are incorporated into
        the ShareMy <Link to="/terms-of-use">Terms of Use</Link> and apply to
        all users, including participants, organizers, ambassadors, promoters,
        and any other individuals using the Services.
      </p>
      <p>By using the Services, you agree to comply with these Guidelines.</p>
      <p>
        Violation of these Guidelines may result in content removal, feature
        restrictions, account suspension, account termination, or other
        enforcement actions, as determined by ShareMy in its sole discretion and
        to the fullest extent permitted by applicable law.
      </p>
      <p>
        These Guidelines supplement the Terms of Use. If there is any conflict
        between these Guidelines and the Terms of Use, the Terms of Use control.
      </p>

      <p>
        <b>2. Enforcement</b>
      </p>
      <p>
        ShareMy may investigate potential violations of these Guidelines and may
        take action it reasonably believes is appropriate, including:
      </p>
      <ul>
        <li>Removing content.</li>
        <li>Restricting features.</li>
        <li>Limiting visibility.</li>
        <li>Suspending accounts.</li>
        <li>Terminating accounts.</li>
        <li>
          Reporting unlawful conduct to appropriate authorities where required
          or permitted by law.
        </li>
      </ul>
      <p>
        ShareMy has no obligation to investigate every report, monitor all
        activity, or enforce these Guidelines in every instance.
      </p>
      <p>
        A decision not to enforce these Guidelines in one situation does not
        waive ShareMy's right to enforce them in another.
      </p>

      <p>
        <b>3. Respect Others</b>
      </p>
      <p>Treat other users with respect.</p>
      <p>You may not:</p>
      <ul>
        <li>Harass or intimidate others.</li>
        <li>Threaten violence.</li>
        <li>Stalk another user.</li>
        <li>Bully or abuse others.</li>
        <li>Encourage self-harm.</li>
        <li>Promote hatred or discrimination against protected groups.</li>
        <li>Engage in unwanted sexual conduct.</li>
        <li>Share intimate images without consent.</li>
      </ul>

      <p>
        <b>4. Be Honest</b>
      </p>
      <p>Users may not:</p>
      <ul>
        <li>Impersonate another person or organization.</li>
        <li>Misrepresent identity.</li>
        <li>Misrepresent qualifications.</li>
        <li>Misrepresent certifications.</li>
        <li>Misrepresent experience.</li>
        <li>Create fake accounts.</li>
        <li>Mislead users regarding activities.</li>
        <li>Falsify attendance.</li>
        <li>Manipulate reviews or ratings.</li>
      </ul>

      <p>
        <b>5. Protect the Community</b>
      </p>
      <p>You may not use ShareMy to:</p>
      <ul>
        <li>Commit fraud.</li>
        <li>Scam users.</li>
        <li>Steal personal information.</li>
        <li>Solicit money fraudulently.</li>
        <li>Distribute malware.</li>
        <li>Send spam.</li>
        <li>Conduct phishing.</li>
        <li>Manipulate recommendations.</li>
        <li>Abuse referral programs.</li>
        <li>Manipulate ambassador incentives.</li>
        <li>Artificially inflate engagement.</li>
      </ul>

      <p>
        <b>6. Illegal Activity</b>
      </p>
      <p>
        Users may not use ShareMy to facilitate or promote unlawful activity,
        including:
      </p>
      <ul>
        <li>Violence.</li>
        <li>Human trafficking.</li>
        <li>Illegal gambling.</li>
        <li>Illegal drug trafficking.</li>
        <li>Fraud.</li>
        <li>Theft.</li>
        <li>Identity theft.</li>
        <li>Money laundering.</li>
        <li>Any other criminal conduct.</li>
      </ul>

      <p>
        <b>7. User-Organized Activities</b>
      </p>
      <p>
        Unless ShareMy expressly identifies an activity as an Official ShareMy
        Event, all activities are organized and conducted by independent users.
      </p>
      <p>Users who organize activities are responsible for:</p>
      <ul>
        <li>Accurate descriptions.</li>
        <li>Lawful conduct.</li>
        <li>Participant communications.</li>
        <li>Compliance with applicable laws.</li>
      </ul>
      <p>
        Participants remain responsible for deciding whether to participate.
      </p>

      <p>
        <b>8. Ambassadors and Independent Contractors</b>
      </p>
      <p>
        ShareMy may engage ambassadors, promoters, organizers, influencers, or
        other independent contractors under separate written agreements.
      </p>
      <p>
        Unless ShareMy expressly states otherwise in writing, these individuals:
      </p>
      <ul>
        <li>Are independent contractors or independent users.</li>
        <li>Are not employees.</li>
        <li>Are not authorized to bind ShareMy.</li>
        <li>Do not represent ShareMy in a legal capacity.</li>
      </ul>
      <p>Their conduct remains their own responsibility.</p>

      <p>
        <b>9. Platform Integrity</b>
      </p>
      <p>To maintain a trustworthy community, users may not:</p>
      <ul>
        <li>Create duplicate accounts.</li>
        <li>Share accounts.</li>
        <li>Circumvent suspensions.</li>
        <li>Manipulate search rankings.</li>
        <li>Manipulate recommendations.</li>
        <li>Exploit platform features.</li>
        <li>Interfere with security.</li>
        <li>Attempt unauthorized access.</li>
      </ul>

      <p>
        <b>10. Reporting Violations</b>
      </p>
      <p>
        Users are encouraged to report conduct that may violate these
        Guidelines.
      </p>
      <p>ShareMy may review reports but does not guarantee:</p>
      <ul>
        <li>Investigation.</li>
        <li>Response.</li>
        <li>Removal.</li>
        <li>Enforcement.</li>
        <li>Prevention of future harm.</li>
      </ul>
      <p>
        Submitting a report does not create any contractual, fiduciary, or other
        legal duty for ShareMy to investigate or act.
      </p>

      <p>
        <b>11. Updates</b>
      </p>
      <p>ShareMy may update these Community Guidelines from time to time.</p>
      <p>
        Continued use of the Services after updates become effective constitutes
        acceptance of the revised Guidelines.
      </p>
    </div>
  );
};

export default CommunityGuide;
